let dropdown = {
  current: null,

  open: selector => {
    const menu = document.querySelector(selector)

    if (dropdown.current !== selector) {
      dropdown.close()
    }

    dropdown.current = selector

    menu.style.display = 'block'

    setTimeout(() => {
      menu.classList.add('show')
    }, 0)
  },

  close: selector => {
    if (!selector) {
      const menu = document.querySelectorAll(dropdown.current)

      menu.forEach(el => {
        el.classList.remove('show')

        setTimeout(() => {
          el.style.display = ''
        }, 200)
      })
    }

    else {
      const menu = document.querySelectorAll('.dropdown-box')

      menu.forEach(el => {
        el.classList.remove('show')

        el.style.display = ''
      })
    }
  }
}

export {dropdown}